<div class="card shadow-lg" [ngClass]="{ approvedCard: request.Approved == true, elevatedCard: request.ProcessRequiredRole == enums.BOSS, unauthorizedCard: request.AuthorizedBy == undefined && sharedService.isAdmin() == false && sharedService.isBossAccount() == false, normalRequestCard: request.LoanInfo.Scheme !== 'EPF' && request.LoanInfo.Scheme !== 'HUTANG', hutangRequestCard: request.LoanInfo.Scheme === 'HUTANG' }">
  <div class="card-body">
    <div class="row">
      <div class="col-10">
        @if (request.LoanInfo.Scheme === "EPF") {
          <h3>
            <strong> Ticket #{{ request.ID }} - ({{ request.CompanyCode }}) </strong>
          </h3>
        }
        @if (request.LoanInfo.Scheme !== "EPF") {
          <h3>
            <strong>({{ request.LoanInfo.Scheme }}) Request - #{{ request.ID }} - ({{ request.CompanyCode }})</strong>
          </h3>
        }
      </div>
      <div class="col-2 d-inline-flex justify-content-end">
        <h5 class="me-1">
          @if (request.Priority == enums.FIRST_PRIORITY) {
            <span class="badge text-bg-warning d-inline-flex"> <i class="fas fa-star"></i> </span>
          }

          @if (request.SharedProfileId != undefined) {
            <span class="badge text-bg-primary d-inline-flex" [ngClass]="{ 'text-bg-success': request.SharedProfileId == request.ProfileId }"> <i class="far fa-handshake"></i></span>
          }
        </h5>
        <h5 class="me-1">
          @if (request.VerifiedOn != undefined) {
            <i class="fas fa-check-square text-success" #tooltip="matTooltip" [matTooltip]="constructVerifiedMessage(request)" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"></i>
          }
        </h5>
        <h5>
          <span class="badge text-bg-secondary" [ngClass]="{ 'text-bg-secondary': isEPFDateMismatch == false, 'text-bg-danger': isEPFDateMismatch }" #tooltip="matTooltip" [matTooltip]="request.UpdatedOn | date: 'dd-MM-yyyy hh:mm:ss'" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">Date: {{ request.UpdatedOn | date: "dd-MM-yyyy" }}</span>
        </h5>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-12">
        <h5 class="p-0 m-0 viewCustomerLink" style="color: darkslategray" (click)="goToCustomer()">
          <b>{{ request.CustomerName }} | {{ sharedService.processICNum(request.CustomerIC) }} </b>
        </h5>
      </div>
      @if (request.LoanInfo.Scheme === "EPF") {
        <div class="col-12">
          <span style="color: slategray; font-weight: bold"><i class="fas fa-piggy-bank"></i> EPF: {{ request.EPFDate | date: "dd-MM-yyyy" }} | RM{{ request.EpfAmount / 1000 | number: "1.2-2" }}K</span>
        </div>
      }

      @if (request.LoanInfo.Scheme === "HUTANG") {
        <div class="col-12">
          <span style="color: rgb(190, 129, 79); font-weight: bold">
            <i class="fas fa-receipt"></i> HUTANG:
            {{ request.LoanInfo.Principal | number: "1.2-2" }}
          </span>
        </div>
      }

      @if (request.LoanInfo.Scheme === "EPF") {
        <div class="col-12 col-lg-5">
          <span style="color: slateblue; font-weight: bold"><i class="fas fa-money-bill"></i> Loan: {{ request.LoanInfo.Principal / 1000 | number: "1.2-2" }}K | Settlement: RM{{ calculateSettlement(request) / 1000 | number: "1.2-2" }}K </span>
        </div>
      }

      @if (request.LoanInfo.Scheme !== "EPF" && request.LoanInfo.Scheme !== "HUTANG") {
        <div class="col-12 col-lg-5">
          <span style="color: rgb(190, 129, 79); font-weight: bold"
            ><i class="fas fa-money-bill"></i> Loan: RM
            {{ request.LoanInfo.Principal | number: "1.2-2" }}
            | {{ request.LoanInfo.Scheme }}({{ request.LoanInfo.InterestRate | number: "1.2-2" }}%)
          </span>
        </div>
      }
      @if (request.LoanInfo.Scheme !== "EPF") {
        <div class="col-12">
          <span style="color: gray; font-weight: bold">
            <i class="fas fa-comments-dollar"></i>
            Remark:
            {{ request.Remark }}
          </span>
        </div>
      }
      @if (request.LoanInfo.Scheme === "EPF" && sharedService.isBranchManager() == false && sharedService.isStaff() == false) {
        <div class="col-12 col-lg-7">
          <span class="badge" [ngClass]="{ 'bg-danger': calculateRatio(request) > 25, 'bg-success': calculateRatio(request) <= 25 }">+ Ratio : {{ calculateRatio(request) | number: "1.3-3" }}%</span>
          @if (request.Guarantors.length == 0) {
            <span class="badge text-bg-danger ms-1"><i class="fas fa-times"></i> Guarantor</span>
          }
          @if (request.Guarantors.length > 0) {
            <span class="badge text-bg-success ms-1"><i class="fas fa-check"></i> Guarantor</span>
          }
          @if (request.HasIAccount == false) {
            <span class="badge text-bg-danger ms-1"><i class="fas fa-times"></i> I-Account</span>
          }
          @if (request.HasIAccount == true) {
            <span class="badge text-bg-success ms-1"><i class="fas fa-check"></i> I-Account</span>
          }
          @if (adminAccess !== undefined && (sharedService.isBossAccount() || sharedService.isFinance())) {
            <ng-template #popContent>
              @for (a of adminAccess; track a) {
                <div class="fs-6">
                  {{ a.Priority }}: <b>{{ a.Username }}</b>
                </div>
              }
            </ng-template>
            <ng-template #popTitle>Admins</ng-template>
            <a role="button" class="ms-1 badge text-decoration-none text-info-emphasis bg-info-subtle border-info-subtle" [ngbPopover]="popContent" [popoverTitle]="popTitle" autoClose="outside" placement="bottom-start auto" container="body"><i class="fas fa-user-friends me-2"></i>{{ adminAccess[0].Username }}</a>
          }
        </div>
      }
    </div>
    <div class="row">
      <div class="col d-flex justify-content-end align-items-right">
        @if ((sharedService.isAdmin() == true || sharedService.isBossAccount() == true) && request.Approved == undefined && (request.LoanGroupId == undefined || request.LoanInfo.Scheme !== "EPF") && disallowProcess == false) {
          <button class="btn" (click)="openReviewLoanRequestModal()" [ngClass]="{ 'btn-info': disallowProcess == false, 'btn-secondary': disallowProcess == true }">
            @if (clashedTickets != undefined && clashedTickets.length > 0) {
              <i class="fas fa-car-crash"></i>
              Review Clashed Request
            } @else {
              <i class="fas fa-file-alt"></i>
              Review
            }
          </button>
        }

        @if ((sharedService.isBranchManager() == true || sharedService.isStaff() == true || sharedService.isFinance()) && request.Approved == undefined) {
          <button class="btn btn-info" (click)="openAuthorizeLoanRequestModal()">
            <i class="fas fa-info"></i>
            View Details
          </button>
        }

        @if ((sharedService.isBranchManager() == true || sharedService.isStaff() == true) && request.Approved == undefined && request.AuthorizedBy != undefined && request.LoanInfo.Scheme === "EPF") {
          <button class="btn btn-success ms-2" (click)="openSendWhatsapp()"><i class="fab fa-whatsapp"></i> Send Whatsapp</button>
        }
      </div>
    </div>
  </div>
</div>
